import React, { FC } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Container, Theme, Typography, Grid } from '@material-ui/core';

interface ProjectsBenefitsProps {
  text: string;
}

interface ProjectsBenefitsArrayProps {
  textList: Array<ProjectsBenefitsProps>;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      marginBottom: theme.spacing(20),
    },
    title: {
      fontWeight: 500,
      color: theme.palette.primary.dark,
    },
    text: {
      marginTop: theme.spacing(4),
    },
    divider: {
      width: '100%',
      height: 1,
      backgroundColor: theme.palette.secondary.light,
      margin: theme.spacing(10, 0),
    },
  });
});

const ProjectsBenefitsSection: FC<ProjectsBenefitsArrayProps> = ({ textList }) => {
  const classes = useStyles();
  return (
    <Container fixed className={classes.root}>
      <Grid container justifyContent="center" direction="row">
        <Grid item lg={8} sm={12}>
          <Typography variant="h4" className={classes.title} data-aos="fade-up">
            Benefits
          </Typography>
          <ul>
            {textList.map((item, index) => (
              <li key={index} data-aos="fade-up">
                <Typography className={classes.text}>{item.text}</Typography>
              </li>
            ))}
          </ul>
        </Grid>
      </Grid>
    </Container>
  );
};
export default ProjectsBenefitsSection;
